import React from "react";

const formatter = new Intl.NumberFormat("en-US");

export default function Count({ children, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span {...props} className="rounded-sm bg-gray-300 px-1.5 py-0.5 text-xs tabular-nums">
      {Number.isInteger(children) ? formatter.format(children as number) : children}
    </span>
  );
}
